export const addKeyProperty = (arr) => {
  if (arr && arr.length > 0) {
    return arr.map((obj) => {
      return { ...obj, key: obj.id };
    });
  }
  return [];
};
